import React from 'react';
import { InputNumber } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import { Form } from 'ui-library';
import { requiredRule } from '../../common/Rules';
import range from 'lodash/range';

const MIN_AMOUNT_PER_MONTH = 0;
const MAX_AMOUNT_PER_MONTH = 999999;
const MAX_PERCENTAGE = 100;

export const getLabel = (value) => getTranslatedString(`landlordPortal.incentives.${value}`);

export const renderAmountPerMonth = (isCalculationTypePercentage) => (
  <Form.Item
    label={getTranslatedString('landlordPortal.incentives.amountPerMonth')}
    name="amount_per_month"
    rules={[requiredRule]}
  >
    <InputNumber
      min={MIN_AMOUNT_PER_MONTH}
      max={isCalculationTypePercentage ? MAX_PERCENTAGE : MAX_AMOUNT_PER_MONTH}
      addonAfter={isCalculationTypePercentage ? '%' : '$'}
    />
  </Form.Item>
);

export const startingMonthOptions = range(1, 19).map((monthNumber) => ({
  value: monthNumber,
  label: getTranslatedString('landlordPortal.incentives.monthNOfLease', { n: monthNumber }),
}));
